import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const baseUrl = "https://www.bibaelectronics.com";

function CanonicalTag() {
  const location = useLocation();

  return (
    <Helmet>
      <link rel="canonical" href={baseUrl + location.pathname} />
    </Helmet>
  );
}

export default CanonicalTag;